import i1 from '../Assets/ImageGallery/1.jpeg';
import i2 from '../Assets/ImageGallery/7.jpg';
import i3 from '../Assets/ImageGallery/3.jpg';
import i4 from '../Assets/ImageGallery/4.jpg';
import i5 from '../Assets/ImageGallery/5.jpg';
import i6 from '../Assets/ImageGallery/6.jpg';


export const gallery = [i1, i2, i3, i4,i5,i6];
